import { atom, selector } from 'recoil';

export const activeIndexRecoil = atom<number | null>({
  key: 'activeIndexRecoil',
  default: null,
});

export const activeSubIndexRecoil = atom<number | null>({
  key: 'activeSubIndexRecoil',
  default: null,
});

export const openMenuIndexRecoil = atom<number | null>({
  key: 'openMenuIndexRecoil',
  default: null,
});
